import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-heading font-bold text-primary-400">奶片动漫</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              你的专属动漫追番基地，涵盖热门新番、经典老番、国漫、日漫等海量资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-categories" className="cursor-pointer">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category?tab=${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>support@naipiananime.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-primary-400"></i>
                <span>@奶片动漫官方</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2025 奶片动漫 版权所有 | 用心服务每一位动漫爱好者
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}